/** Detect Firestore SDK internal watch stream assertion failures (transient, requires reload). */
export function isFirestoreAssertionError(error: unknown): boolean {
  return error instanceof Error && !!error.message?.includes('INTERNAL ASSERTION FAILED');
}
